module.exports = __webpack_public_path__ + "media/images/cms/img_slide_09-7ec999de34be46bc36130e8bac0dcbc7.jpg";